export default function CertificationBanner() {
  return (
    <div className="relative overflow-hidden" style={{ minHeight: '260px' }}>
      <img
        src="/assets/img/686f0680252e.webp"
        alt="Certification banner background"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/65" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-14 flex flex-col md:flex-row items-center gap-10 md:gap-0 justify-between">
        <div className="text-white text-center md:text-left md:w-48 shrink-0">
          <p className="text-xs uppercase tracking-widest text-teal-300 font-semibold mb-1">Certified &amp; Tested</p>
          <h3 className="text-2xl font-bold leading-tight">Industry<br />Accreditations</h3>
        </div>

        <div className="hidden md:block w-px h-24 bg-white/20 mx-8" />

        <div className="flex flex-col sm:flex-row gap-10 flex-1 justify-around items-center">
          <img
            src="/assets/img/d85babcb114d.webp"
            alt="Fire Rated Badge"
            className="h-36 w-auto object-contain drop-shadow-lg"
          />
          <img
            src="/assets/img/4ad02948cc57.webp"
            alt="Fire Rated Badge"
            className="h-36 w-auto object-contain drop-shadow-lg"
          />
        </div>
      </div>
    </div>
  );
}
